window.jQuery = require('jquery')

window.$ = jQuery

import 'bootstrap';

//import 'owl.carousel';

//import '../node_modules/owl.carousel/dist/assets/owl.carousel.min.css';

import '../scss/main.scss';

window.designamite = {

  init: function()
  {

    designamite.global.init()
    
    designamite.cookie.init()

  },

  global: require('./methods/global'),
  
  cookie: require('./methods/cookie-bar'),

}

$(document).ready(designamite.init);